import {
  Typography,
  Alert,
  Button,
  Grid
} from '@mui/material';
import { Plus } from 'mdi-material-ui';
import { useEffect, useState } from 'react'
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import Spinner from '../../components/spinner'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogPopup from '../../views/popup/DialogPopup'
import PopupWrapper from '../../views/popup/PopupWrapper'


const PopupList = () => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [show, setShow] = useState(false)
  const [reload, setReload] = useState(0)

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiService.get('/popups')
      const payload = response.data;

      setItems(payload.list)
      setLoading(false)
    }

    fetchData().catch(e => console.error(e));
  }, [reload]);

  return (
    loading ?
    <Spinner/>
    :
    <Page title="Popup">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              팝업 관리
            </Typography>
          }
          subtitle={
            <Typography variant='body2'>
              빠른 공지를 위해서 팝업을 사용자에게 보여주세요
            </Typography>
          }
        />
        <BoxWrapper>
          <Button variant='contained' startIcon={<Plus />} onClick={() => setShow(true)} >등록</Button>
        </BoxWrapper>
        <DialogPopup show={show} setShow={setShow} reload={reload} setReload={setReload} />
        <Grid item xs={12}>
          {items.length > 0 ? (
            <PopupWrapper items={items} setItems={setItems} />
          ) : (
            <Alert severity='warning'>팝업 데이타가 없습니다 — <strong>새로 만들어보세요</strong></Alert>
          )}
        </Grid>
      </Grid>
    </Page>
  )
}

export default PopupList